<template lang="pug">
div
  section.u-mt-md
    AppTitle.u-mb-xm(:title="$t('mantra')")



  section.u-mt-md
    .grid.is-widescreen-4.is-tablet-6
      .column.u-mb-sm(v-for="item,idx in $t('sec1Items')")
        h4 {{item.title}}
        p.u-mb-ts {{item.desc}}
        AppLink(v-if="item.url" :to="item.url" :title="$t('learnMore')" class="button-link is-small") {{$t('learnMore')}}

  section.u-mt-md
    .grid.is-widescreen-8.is-desktop-10
      .column
        AppTitle.u-mb-0(:title="$t('sec2')" tag="h3")


  section.u-mt-md
    .grid
      .column.is-widescreen-5
        AppTitle.u-mb-mi(:title="$t('sec3')" tag="h2")
      .column.is-widescreen-7
        .grid.is-tablet-6
          .column.u-mb-sm(v-for="item,idx in $t('sec3Items')")
            h4 {{item.title}}
            p {{item.desc}}

  section.u-mt-md
    .grid.is-widescreen-8.is-desktop-10
      .column
        AppTitle.u-mb-0(:title="$t('sec4')" tag="h3")

  section.u-mt-md.u-mb-md
    AppLink(to="/ordering" :title="$t('cta')" class="button-link is-large " v-html="$t('cta')")

</template>

<script>
export default {
  head() {
    const $t = this.$t.bind(this);
    return {
      title: $t('pageTitle'),
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: $t('pageTitle')
        },
        {
          hid: 'description',
          name: 'description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:image',
          name: 'og:image',
          property: 'og:image',
          content: 'https://cdn.baianat.com/static/share/services.png'
        },
        {
          hid: 'twitter:image',
          name: 'twitter:image',
          property: 'twitter:image',
          content: 'https://cdn.baianat.com/static/share/services.png'
        }
      ]
    };
  }
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Baianat marketing",
    "pageDesc":"Creating marketing plans and campaigns that capitalize on social media, email marketing, SEO, content and other channels.",
    "mantra":"Authentic marketing |approach",
    "sec1Items":{
      "1":{
        "title":"Social media",
        "desc":"Helping you build a community online and speak with your audience through a consolidated social media strategies and campaigns that are targeted and sometimes paid. Using analytics tools, A/B testing to generate reports and optimize for better results. ",
        "url":"/services/social-media"
      },
      "2":{
        "title":"SEO",
        "desc":"Get found by crawlers and be visible for all your business audience using On-site and Off-site techniques. Conduct SEO audit, analyze your website speed, rankings and traffic.",
        "url":"/services/search-engine-optimization"
      },
      "3":{
        "title":"Content marketing",
        "desc":"Creating useful and engaging content for all your digital channels and strategically distributing it to reach more people online.",
        "url":"/services/content-creation"
      },
      "4":{
        "title":"ASO",
        "desc":"Get discovered on the store with App store optimization techniques. Hack your downloads rate and plan ahead for your application virality.",
        "url":"/services/app-marketing"
      },
      "5":{
        "title":"Marekting conuslting",
        "desc":"Following our process, we help you define the business problem and suggest our plans for solving it. We set the goals and objectives and work towards achieving through a strategic planning process."
      },
      "6":{
        "title":"Email marketing",
        "desc":"Hit inboxes and get better conversion rates without being spammy or interruptive through email campaigns that is designed to delight."
      },
      "7":{
        "title":"App marketing",
        "desc":"Enticing your App users through the different stages of the buyer’s journey with push notifications and customized offers.",
        "url":"/services/app-marketing"
      }
    },
    "sec2":"Interruptive marketing is outdated. We follow an inbound authentic marketing methodology so could focus on the end benefit rather than fake sales increase.",

    "sec3":"Marketing that supports your business goals.",
    "sec3Items":{
      "1":{
        "title":"Lead generation",
        "desc":"Whether you're launching a new product  or in need for sale sincrease, we help you attract potential leads and generating demand for your product or service."
      },
      "2":{
        "title":"Lead nurturing",
        "desc":"We help you capitalize on your clients database by turning your current clients into advocates and regingaging those who abandoned the service."
      }
    },
    "sec4":"There are 50+ marketing types in the world. And we believe the secret lies in how they are mixed.",

    "cta":"Get your marketing <br> plan now."
  },
  "ar": {
    "pageTitle":"التسويق",
    "pageDesc":"نؤسس وننشئ خطط التسويق والحملات المختلفة التي تؤثر على وسائل التواصل الإجتماعي والبريد والسيو والمحتوى والقنوات الاخري.",
    "mantra":"تواصل عبر مختلف الأوساط |من خلال خطط التسويق.",
    "sec1Items":{
      "1":{
        "title":"وسائل التواصل الإجتماعي",
        "desc":"نساعدك على التواصل مع جمهورك من خلال إعداد استراتيجيات وحملات وسائل التواصل الإجتماعي سواء كانت مجانية أو مدفوعة. باستخدام أدوات التحليل، واختبار أ / ب لإنشاء تقارير والتوصل إلى  نتائج أفضل.",
        "url":"/services/social-media"
      },
      "2":{
        "title":"تحسين محركات البحث",
        "desc":"اجعل من السهل على عناكب الزحف أرشفة موقعك لتظهر في المراتب الأولي في صفحة النتائج وبذلك تمكن الجمهور المستهدف من العثور عليك بسهولة من خلال اتباع الممارسات التقنية على  On-site و Off-site. نعمل على إجراء تدقيق السيو وتحليل سرعة الموقع وترتيبك في محركات البحث وكذلك حركات الزوار.",
        "url":"/services/search-engine-optimization"
      },
      "3":{
        "title":"التسويق بالمحتوى",
        "desc":"نعمل على إنشاء محتوى مفيد وجذاب لجميع قنواتك الرقمية، وكيف نعمل بشكل استراتيجي للوصول إلى المزيد من الجمهور. ",
        "url":"/services/content-creation"
      },
      "4":{
        "title":"التحسين على متجر التطبيقات (ASO)",
        "desc":"اجعل من السهل على جمهورك العثور عليك في متجر التطبيقات من خلال اتباع تقنيات ASO، و حسّن من معدل التحميلات التي تحصل عليها.",
        "url":"/services/app-marketing"
      },
      "5":{
        "title":"استشارات التسويق",
        "desc":"باتباع عمليتنا، نساعدك على تحديد مشكلة البيزنس واقتراح الخطط الأمثل لحلها. ثم نضع الأهداف ونعمل على تحقيقها من خلال عملية التخطيط الاستراتيجي."
      },
      "6":{
        "title":"التسويق عبر البريد الإلكتروني",
        "desc":"من خلال الممارسات التي نتبعها نساعدك على الوصول إلى صندوق البريد الخاص بعملائك والحصول على أفضل معدلات التحويل بدون الاعتماد على البريد المزعج (spam)."
      },
      "7":{
        "title":"تسويق التطبيقات",
        "desc":"حفز مستخدمي التطبيق من خلال الإشعارات(push notifications) والعروض المخصصة.",
        "url":"/services/app-marketing"
      }
    },
    "sec2":"الاعتماد على أسلوب المقاطعة في التسويق ما هو إلا منهجية قديمة. نتبع منهجية الإنباوند في التسويق بحيث يمكننا التركيز على الفائدة النهائية بدلاً من زيادة المبيعات المزيفة.",

    "sec3":"ادعم أهداف البيزنس من خلال التسويق.",
    "sec3Items":{
      "1":{
        "title":"جذب العملاء المحتملين (Lead generation)",
        "desc":"سواء كنت تطلق منتجًا جديدًا أو في حاجة إلى البيع، سوف نساعدك على جذب العملاء المحتملين وزيادة الطلب على منتجك أو خدمتك."
      },
      "2":{
        "title":"الحفاظ على العملاء الحاليين (Lead nurturing) ",
        "desc":"نساعدك على الاستفادة من قاعدة بيانات العملاء الخاصة بك عن طريق تحويل عملائك الحاليين إلى مروجين لعلامتك التجارية وإعادة تحفيز العملاء الذين تركوا الخدمة."
      }
    },
    "sec4":"هناك أكثر من 50 نوع من التسويق في العالم. ونعتقد أن السر يكمن في كيفية مزجهم.",

    "cta":"احصل على خطتك <br> التسويقة الآن."
  }
}
</i18n>
